import { cnBase } from 'tailwind-variants';
import { CoinIcon } from '../../../../assets/icons/CoinIcon';
import { Typography } from '../../molecules/Typography';
import { useMemo } from 'react';

const BadgeScore = ({
  score,
  type = 'warning',
}: {
  score: boolean | (string | number)[] | string | number;
  type?: 'warning' | 'success' | 'error' | 'default' | undefined;
}) => {
  const scores = Array.isArray(score) ? score : [score];

  const scoreFormatted = scores.join(' a ');

  const className = {
    warning:
      'border-feedback-color-warning-pure bg-feedback-color-warning-lightest',
    success:
      'border-feedback-color-success-pure bg-feedback-color-success-lightest',
    error: 'border-feedback-color-error-pure bg-feedback-color-error-lightest',
    default:
      'border-feedback-color-warning-pure bg-feedback-color-warning-lightest',
  };

  const textColor = {
    warning: 'text-feedback-color-warning-darkest',
    success: 'text-feedback-color-success-darkest',
    error: 'text-feedback-color-error-darkest',
    default: 'text-feedback-color-warning-darkest',
  };

  const scoreString = useMemo(() => {
    let response =
      Number(scoreFormatted) === 1
        ? `${scoreFormatted} ponto`
        : `${scoreFormatted} pontos`;

    if (type === 'success') {
      if (Number(scoreFormatted) === 1) {
        response += ' ganho';
      } else {
        response += ' ganhos';
      }
    }

    return response;
  }, [scoreFormatted, type]);

  return (
    <div
      className={cnBase(
        'flex flex-row items-center gap-xs rounded-pill border-hairline px-2 py-1',
        className[type]
      )}
    >
      <CoinIcon />
      <Typography
        size='small'
        type='title'
        className={cnBase('text-h5 text-center', textColor[type])}
      >
        {scoreString}
      </Typography>
    </div>
  );
};

export { BadgeScore };
